// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DummyInputPlaceholder_wrap__2_9ka"};